<mat-dialog-content>
    <mat-icon *ngIf="data.icon" style="margin-right:5px;">{{data.icon}}</mat-icon>
    <span style="white-space: pre-wrap;" [innerHtml]="data.message"></span>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button *ngFor="let button of data.buttons" mat-raised-button [color]="button.color" (click)="buttonClick(button)">
        <mat-icon *ngIf="button.icon" style="margin-right:5px;">{{button.icon}}</mat-icon>
        <span>{{button.text}}</span>
    </button>
</mat-dialog-actions>